import { AppThunk } from '../../../store/rootReducer';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as ecgClient from '../../ecg/clients/ecg.client';
import * as clusterActions from '../actions/cluster.actions';
import * as morphologyActions from '../actions/morphology.actions';
import * as beatsActions from '../../beats/beats.actions';
import { getClusters } from '../client/cluster.client';
import { getDurationFromNumberOfPoints, SIDE_POINTS } from '../client/helpers';

export const loadClusters =
  (ecgId: string): AppThunk =>
  async (dispatch) => {
    const ecg = await ecgClient.getEcg(ecgId);

    if (ecg != null) {
      await dispatch(
        ecgActions.loaded({
          ecg: {
            analysisType: ecg.analysisType,
            recordType: ecg.recordType,
            duration: getDurationFromNumberOfPoints(2 * SIDE_POINTS),
            ecgId,
            errorType: ecg.errorType,
          },
          meta: { history: false },
        }),
      );

      const clusters = await getClusters(ecg);
      if (clusters != null) {
        const { morphologies, baseClusters } = clusters;
        dispatch(morphologyActions.load({ morphologies }));
        dispatch(clusterActions.load({ clusters: baseClusters }));
        if (baseClusters.length > 0) {
          dispatch(beatsActions.load({ beats: baseClusters[0].beats }));
        }
      }
    }
  };
